// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { HasCartContext, withCart } from "@insite/client-framework/Components/CartContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { LinesHeaderStyles } from "@pace/App/Components/Cart/LinesHeader";
import { CustomAppState } from "@pace/App/Store/Reducers";
import CartLinesList, { CartLinesListStyles } from "@pace/Overrides/Components/CartLinesList";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => {
    const settingsCollection = getSettingsCollection(state);
    // XNG-Change
    const isTabletScreen = (state as CustomAppState).xCommon.isTabletScreen;
    return {
        showSavingsAmount: settingsCollection.productSettings?.showSavingsAmount,
        showSavingsPercent: settingsCollection.productSettings?.showSavingsPercent,
        isTabletScreen,
    };
};

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & HasCartContext;

export interface OrderApprovalDetailsProductListStyles {
    centeringWrapper?: InjectableCss;
    orderLinesList?: CartLinesListStyles;
    // XNG-change
    cartLinesHeaderStyle?: LinesHeaderStyles;
}

export const productListStyles: OrderApprovalDetailsProductListStyles = {
    centeringWrapper: {
        css: css`
            display: flex;
            justify-content: center;
            align-items: center;
            height: 300px;
        `,
    },
};

export const styles = productListStyles;

const OrderApprovalDetailsProductList = ({
    showSavingsAmount,
    showSavingsPercent,
    cart,
    // XNG-Change
    isTabletScreen,
}: Props) => {
    const [isCondensed, setIsCondensed] = useState(false);

    // XNG-Change
    useEffect(() => {
        isTabletScreen ? setIsCondensed(false) : null;
    }, [isTabletScreen]);

    if (!cart) {
        return null;
    }

    return (
        <CartLinesList
            cart={cart}
            isCondensed={isCondensed}
            onChangeIsCondensed={(event: React.SyntheticEvent<Element, Event>, value: boolean) => setIsCondensed(value)}
            editable={false}
            showSavingsAmount={showSavingsAmount}
            showSavingsPercent={showSavingsPercent}
            extendedStyles={styles.orderLinesList}
            // XNG-Change
            cartLinesHeaderStyle={styles.cartLinesHeaderStyle}
            hideCondensedSelector={isTabletScreen}
            headerTitles={["", translate("Price/Unit"), translate("Qty Ordered"), translate("Extended Price")]}
        />
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withCart(OrderApprovalDetailsProductList)),
    definition: {
        displayName: "Product List",
        allowedContexts: ["OrderApprovalDetailsPage"],
        group: "Order Approval Details",
    },
};

export default widgetModule;
